import { Controller } from "@hotwired/stimulus"

// Manages checkbox-style ingredient selection using hidden inputs + CSS .selected class.
// Each .ingredient-option row contains a hidden input with value 0 or 1.
export default class extends Controller {
  static targets = ["option"]
  static values  = { max: { type: Number, default: -1 } }

  toggle(event) {
    const row   = event.currentTarget
    const input = row.querySelector("input[type=hidden]")
    if (!input) return

    const isSelected = row.classList.contains("selected")

    // Radio behaviour: max === 1 → deselect others first
    if (this.maxValue === 1 && !isSelected) {
      this.optionTargets.forEach(opt => {
        opt.classList.remove("selected")
        const inp = opt.querySelector("input[type=hidden]")
        if (inp) inp.value = "0"
      })
    }

    // Enforce max limit (skip if unlimited or deselecting)
    if (!isSelected && this.maxValue !== -1) {
      const selectedCount = this.optionTargets.filter(o => o.classList.contains("selected")).length
      if (selectedCount >= this.maxValue) return
    }

    // Toggle selection
    if (isSelected) {
      row.classList.remove("selected")
      input.value = "0"
    } else {
      row.classList.add("selected")
      input.value = "1"
    }

    // Notify price recalculation + requirement status
    this.dispatch("priceChange", { bubbles: true })
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }

  connect() {
    // Initial state is set via server-rendered classes and values
  }
}